import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { FormEditProfile } from "./FormEditProfile";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";

export const PanelEditProfile = () => {
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [permissions, setPermissions] = useState([]);
  const [managers, setManagers] = useState([]); // New state for managers
  const [data, setData] = useState({
    name: "",
    role: "",
    email: "",
    photo: null,
    active: 1,
    password: "",
    password_confirmation: "",
    permissions: [],
    manager_id: null, // Add manager_id to initial data
  });

  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: api_Routes.Profile.Get,
      });

      if (response) {
        setData({
          name: response.data.name || "",
          role: response.data.role || "",
          email: response.data.email || "",
          photo: response.data.photo || "",
          active: response.data.active ? 1 : 0,
          password: "",
          password_confirmation: "",
          permissions: response.data.permissions || [],
          manager_id: response.data.manager_id || null, // Set manager_id from API
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };



  useEffect(() => {
    getData();
  }, []);

  return (
      <div>
        <PanelHead
            title={
              isLoading ? (
                  <div className="flex items-center gap-4">
                    Edit Profile <CircularProgress size={24} />
                  </div>
              ) : (
                  <div className="flex items-center justify-between w-full gap-4">
                    <div>Edit Employee: {data?.name}</div>
                  </div>
              )
            }
        />
        <PanelBody
            content={
              isLoading ? (
                  <LinearProgress />
              ) : (
                  <FormEditProfile
                      data={data}
                      // permissions={permissions}
                      managers={managers} // Pass managers to form
                      setData={setData}
                  />
              )
            }
        />
      </div>
  );
};